<template>
    <sidebar-menu :items="menuWithRoutes" force-expanded @update:expanded="$emit('update:expanded', $event)" />
</template>

<script>
import { mapGetters } from 'vuex';

import SidebarMenu from '@/components/sidebar/SidebarMenu.vue';

export default {
    name: 'HelpSidebar',

    components: { SidebarMenu },

    emits: ['update:expanded'],

    computed: {
        ...mapGetters('Menu', ['menu']),

        menuWithRoutes() {
            return this.addRoutes(this.menu);
        },
    },

    methods: {
        addRoutes(items) {
            if (!items) return items;

            const list = Array.isArray(items) ? items : Object.values(items);

            return list.map(item => {
                if (item.type === 'item') {
                    return { ...item, route: `/help/${item.slug || item.id}` };
                }

                if (item.items) {
                    return { ...item, items: this.addRoutes(item.items) };
                }

                return item;
            });
        },
    },
};
</script>
